import styled from 'styled-components';

export const LogoContainer = styled.div`
    align-items: center;
    align-self: start;
    min-width: fit-content;
    width: 192px;
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
    svg {
        height: 3rem;
        padding: unset;
    }
    @media (max-width: ${({ theme }) => theme.grid.breakpoints.md}) {
        width: 144px;
        padding: 0 16px;
    }
`;
